import { Icon, type IconName } from "./Icon";

export type Tone = "neutral" | "waiting" | "success" | "danger" | "info" | "attention";

const ICON: Record<Tone, IconName> = {
  neutral: "info",
  waiting: "hourglass-medium",
  success: "check-circle",
  danger: "x-circle",
  info: "info",
  attention: "warning-circle",
};

/** Durum etiketi: renk + ikon + metin (yalnız renkle anlatılmaz). */
export function Status({ tone, children, detail }: { tone: Tone; children: React.ReactNode; detail?: React.ReactNode }) {
  return (
    <span className={`status status--${tone}`}>
      <Icon name={ICON[tone]} size={16} />
      <span className="status__label">{children}</span>
      {detail && <span className="status__detail">{detail}</span>}
    </span>
  );
}

export function leaveTone(status: string): Tone {
  switch (status) {
    case "pending":
      return "waiting";
    case "approved":
    case "paid":
      return "success";
    case "rejected":
      return "danger";
    case "returned":
      return "attention";
    default:
      return "neutral";
  }
}
